import {
    closeConversation,
    endConversation,
} from '../../../actions/modal'
import {
    useChannelDetails,
    useQueueName,
} from 'hooks/ninchat'
import React from 'react'
import {SidebarAudiencePros} from '../types'
import SidebarAudienceView from './SidebarAudienceView'
import {navigation} from 'navigation'
import {useAppDispatch} from 'hooks'


const SidebarAudience = ({
    channel_id, nested, isGroupQueue,
}: SidebarAudiencePros): React.ReactElement => {
    const dispatch = useAppDispatch()

    const closeConversationModal = () => {
        dispatch(closeConversation({
            channelId: channel_id,
            show: true,
        }))
    }

    const endConversationModal = () => {
        dispatch(endConversation({
            channelId: channel_id,
            show: true,
        }))
    }

    const loadChannel = (): void => {
        navigation.push('Channel', {channel_id})
    }
    const channelDetails = useChannelDetails({channelId: channel_id})
    const queueName = useQueueName(channelDetails.queueId!)

    const viewProps = {
        channelDetails,
        channelId: channel_id,
        closeConversationModal,
        endConversationModal,
        isGroupQueue,
        loadChannel,
        nested,
        queueName,
    }

    return <SidebarAudienceView {...viewProps} />
}
export default SidebarAudience
